import type { DomainMapper } from '../types';

const fi: DomainMapper = {
  countryCode: 'fi',
  currency: 'EUR',
  domain: 'kahrs-stage.iveo.store',
  environment: 'stage',
  flagUrl: '/flags/FI.svg',
  languagePrimary: true,
  locale: 'fi',
  logoUrl: 'kahrs-logo',
  noRobots: true,
  sitemapUrl: 'https://kahrs.stage3.iveo.se/storage/sitemaps/sitemap-fi.xml',
  storyblokBasePath: 'fi',
  url: 'https://kahrs-stage.iveo.store/fi',
  algoliaIndex: 'b2b-fi-fi-FI-products',
  algoliaIndexAutocomplete: 'b2b-fi-fi-FI-products-products_query_suggestions',
  algoliaIndexPages: 'content_',
  applicationId: 1354,
  subFolder: true,
  b2b: {
    enabled: true,
    purchaseEnabled: true,
    storyblokBasePath: 'b2b',
    applicationId: 1354,
    algoliaIndex: 'b2b-fi-fi-FI-products',
    algoliaIndexAutocomplete: 'b2b-fi-fi-FI-products_query_suggestions',
    displayIncVat: false,
    default: true,
    productBasePath: 'b2b/product',
    sitemapUrl: 'https://kahrs.stage3.iveo.se/storage/sitemaps/sitemap-se.xml',
  },
  b2c: {
    enabled: false,
    purchaseEnabled: false,
    storyblokBasePath: '',
    applicationId: 1354,
    algoliaIndex: 'b2c-fi-fi-FI-products-products',
    algoliaIndexAutocomplete: 'b2c-fi-fi-FI-products_query_suggestions',
    displayIncVat: true,
    default: true,
    productBasePath: 'product',
    sitemapUrl: 'https://kahrs.stage3.iveo.se/storage/sitemaps/sitemap-fi-b2c.xml',
  },
  features: {
    fastOrder: true,
    backorders: false,
    cartSettings: true,
  },
  showNonPublicProducts: true,
} as DomainMapper;

export default fi;
